import * as firebase from 'firebase';
import fire from '../firebase';
import request from './request';

const db = fire.firestore();

export async function findChat(idChat, user1, user2) {
  if (idChat) {
    // Find chat by id
    const chatDoc = await db.collection('chats').doc(idChat).get();
    if (chatDoc.exists) {
      const chatData = chatDoc.data();
      return { id: chatDoc.id, ...chatData };
    } else return null;
  } else {
    // Find chat by users
    const [querySnapshot1, querySnapshot2, querySnapshot3, querySnapshot4, querySnapshot5, querySnapshot6, querySnapshot7, querySnapshot8] = await Promise.all([
      // Case 1 | User1 - User2 | No chat deleted
      db
        .collection('chats')
        .where('users', '==', [
          { id: user1, deleted: false, deleted_chat: false },
          { id: user2, deleted: false, deleted_chat: false },
        ])
        .limit(1)
        .get(),
      // Case 2 | User1 - User2 | Chat deleted by both
      db
        .collection('chats')
        .where('users', '==', [
          { id: user1, deleted: false, deleted_chat: true },
          { id: user2, deleted: false, deleted_chat: true },
        ])
        .limit(1)
        .get(),
      // Case 3 | User1 - User2 | Chat deleted by User1
      db
        .collection('chats')
        .where('users', '==', [
          { id: user1, deleted: false, deleted_chat: true },
          { id: user2, deleted: false, deleted_chat: false },
        ])
        .limit(1)
        .get(),
      // Case 4 | User1 - User2 | Chat deleted by User2
      db
        .collection('chats')
        .where('users', '==', [
          { id: user1, deleted: false, deleted_chat: false },
          { id: user2, deleted: false, deleted_chat: true },
        ])
        .limit(1)
        .get(),
      // Case 5 | User2 - User1 | No chat deleted
      db
        .collection('chats')
        .where('users', '==', [
          { id: user2, deleted: false, deleted_chat: false },
          { id: user1, deleted: false, deleted_chat: false },
        ])
        .limit(1)
        .get(),
      // Case 6 | User2 - User1 | Chat deleted by both
      db
        .collection('chats')
        .where('users', '==', [
          { id: user2, deleted: false, deleted_chat: true },
          { id: user1, deleted: false, deleted_chat: true },
        ])
        .limit(1)
        .get(),
      // Case 7 | User2 - User1 | Chat deleted by User2
      db
        .collection('chats')
        .where('users', '==', [
          { id: user2, deleted: false, deleted_chat: true },
          { id: user1, deleted: false, deleted_chat: false },
        ])
        .limit(1)
        .get(),
      // Case 8 | User2 - User1 | Chat deleted by User1
      db
        .collection('chats')
        .where('users', '==', [
          { id: user2, deleted: false, deleted_chat: false },
          { id: user1, deleted: false, deleted_chat: true },
        ])
        .limit(1)
        .get(),
    ]);

    const results = [];

    // QuerySnapshot is empty is the chat does not exist
    querySnapshot1.forEach(doc => results.push(doc));
    querySnapshot2.forEach(doc => results.push(doc));
    querySnapshot3.forEach(doc => results.push(doc));
    querySnapshot4.forEach(doc => results.push(doc));
    querySnapshot5.forEach(doc => results.push(doc));
    querySnapshot6.forEach(doc => results.push(doc));
    querySnapshot7.forEach(doc => results.push(doc));
    querySnapshot8.forEach(doc => results.push(doc));

    let chatData = null;
    if (results.length) {
      const data = results[0].data();
      chatData = { id: results[0].id, ...data };
    }

    return chatData;
  }
}

export async function createChat(currentUser, otherUser) {
  const chat = {
    last_message: '',
    participants: [parseInt(currentUser.id), parseInt(otherUser.id)],
    users: [
      {
        id: parseInt(currentUser.id),
        deleted: false,
        deleted_chat: false,
      },
      {
        id: parseInt(otherUser.id),
        deleted: false,
        deleted_chat: false,
      },
    ],
    deleted: false, // Deleted by both users
    deleted_by: null, // Who deleted the chat
    show_messages_after: firebase.firestore.Timestamp.fromDate(new Date()), // To hide previous messages from the user who previously deleted the chat
    updated_at: firebase.firestore.Timestamp.fromDate(new Date()),
    created_at: firebase.firestore.Timestamp.fromDate(new Date()),
    [`${currentUser.id}_read`]: true,
  };

  return await db.collection('chats').add(chat);
}

export async function startChat(loading, user, currentUser) {
  loading = true;
  const memberRef = await db.collection('users').doc(`${user?.id}`);
  const currentUserRef = await db.collection('users').doc(`${currentUser?.id}`);

  const userSnapshot = await memberRef.get();
  const meSnapshot = await currentUserRef.get();

  if (!userSnapshot.exists) {
    memberRef.set({
      username: user?.name || user?.fullname || user?.slug,
      first_name: user?.first_name,
      last_name: user?.last_name,
      picture: user?.profile_image,
    });
  }

  if (!meSnapshot.exists) {
    currentUserRef.set({
      username: currentUser?.username || currentUser?.fullname || currentUser?.slug,
      first_name: currentUser?.first_name,
      last_name: currentUser?.last_name,
      picture: currentUser?.profile_image,
    });
  }

  const chat = await findChat(null, parseInt(currentUser.id), user.id);

  let newChatId = null;

  if (!chat || chat?.deleted) {
    const newChat = await createChat(currentUser, user);
    newChatId = newChat.id;
  }

  const chatId = chat?.id || newChatId;
  window.location.href = `/user/chats?${chatId}`;
  loading = false;
}

export function sendEmail(id) {
  return request('post', `/apiv2/user/notify-new-message/${id}`, {});
}
